<div class="privacy-terms-wrapper" *ngIf="!hideTrigger">
  <p>{{ 'general.copyright' | translate: { year: currentYear } }}</p>
  <p (click)="open()" (keydown.enter)="open()" tabindex="0">
    {{ 'general.privacyAndTerms' | translate }}
  </p>
</div>
